import _extends from "@babel/runtime/helpers/extends";
import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { HeaderName } from 'carbon-components-react';

const HeaderLogo = ({
  alt,
  className: customClassName,
  href,
  src,
  title,
  ...rest
}) => {
  const className = cx('om-header__logo', customClassName);
  return /*#__PURE__*/React.createElement(HeaderName, _extends({}, rest, {
    className: className,
    href: href,
    prefix: ""
  }), /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt,
    title: title
  }));
};

HeaderLogo.propTypes = {
  /**
   * Provide the alt text that will be applied to the logo image
   */
  alt: PropTypes.string.isRequired,

  /**
   * Optionally provide a custom class to apply a node
   */
  className: PropTypes.string,

  /**
   * Provide an href for the name to link to
   */
  href: PropTypes.string.isRequired,

  /**
   * Provide the source url or path to the logo
   */
  src: PropTypes.string.isRequired,

  /**
   * Provide the title that will be applied to the logo image
   */
  title: PropTypes.string.isRequired
};
export default HeaderLogo;